export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <div className={`brand${compact ? " brand--compact" : ""}`} aria-label="Imprint">
      <img className="brand__mark" src="/icons/imprint.svg" alt="" aria-hidden="true" />
      <span>IMPRINT</span>
    </div>
  );
}
